import React, { useState, useEffect } from "react";
import AgoraUIKit, { layout } from "agora-react-uikit";
import axios from "axios";
import { MdOutlineErrorOutline } from "react-icons/md";
import AgoraRTC, { IAgoraRTCClient } from "agora-rtc-sdk-ng";
import { API_URL } from "../../url/api";
import logo from "../../assets/logos/newLogo.png";

type status = "scheduled" | "completed" | "cancelled";
interface APIResponse {
  success: boolean;
  response: {
    user: {
      id: number;
      name: string;
    };
    therapist: {
      id: number;
      name: string;
    };
    status: status;
  };
}

const AgoraNewVideoCall = () => {
  const [videoCall, setVideoCall] = useState(false);
  const [loading, setLoading] = useState(true);
  const [invalidRoom, setInvalidRoom] = useState(false);
  const [username, setUsername] = useState("");
  const [hasExistingStream, setHasExistingStream] = useState(false);
  const [isTherapist, setIsTherapist] = useState(false);
  
  document.title = "Shvesa Video Call";


  const callbacks = {
    EndCall: () => setVideoCall(false),
  };

  const urlParams = new URLSearchParams(window.location.search);
  const roomid = urlParams.get("room_id") || "93400b7019e3458db34baa918bb0c318";

  const rtcProps = {
    appId: "5ac69d114f964bcb9913e6e909735f40",
    channel: roomid, // your agora channel
    token: null, // use null or skip if using app in testing mode
    enableScreensharing: true,
    mode: "rtc",
    role: "audience",
    layout: layout.pin,
  };


  const handleCloseTheRoom = async () => {
    try {
      const response = await axios.get(`${API_URL}videocall/${roomid}/close/`);
      console.log("Form submitted successfully:", response.data);
      if (response.data.success) {
        setInvalidRoom(true);

        setTimeout(() => {
          window.close();
        }, 3000);
      }
    } catch (error) {
      console.error("Error closing the room:", error);
    }
  };

  useEffect(() => {
    const validateRoom = async () => {
      try {
        const response = await axios.get<APIResponse>(
          `${API_URL}session-details/${roomid}`
        );
        console.log("Form submitted successfully:", response.data);

        if (response.data.success) {
          setInvalidRoom(false);
          if (response.data.response.status === "completed")
            setInvalidRoom(true);
          if (response.data.response.status === "cancelled")
            setInvalidRoom(true);
          const { user, therapist } = response.data.response;
          const userId = window.localStorage.getItem("userId");
          const doctorId = window.localStorage.getItem("doctorId");
          console.log("🚀 ~ validateRoom ~ userId:", userId);
          console.log("🚀 ~ validateRoom ~ doctorId:", doctorId);
          console.log("🚀 ~ validateRoom ~ user:", user);
          if (userId && user.id == parseInt(userId)) {
            setUsername(user.name);
            setVideoCall(true);
          } else if (doctorId && therapist.id == parseInt(doctorId)) {
            setUsername(therapist.name);
            setVideoCall(true);
            setIsTherapist(true);
          } else {
            setInvalidRoom(true);
          }
        } else setInvalidRoom(true);
        setLoading(false);
        console.log("🚀 ~ validateRoom ~ response:", isTherapist);
      } catch (error) {
        console.log("🚀 ~ validateRoom ~ error:", error);
        setLoading(false);
      }
    };

    const checkExistingStream = async () => {
      try {
        const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

        client.on("stream-added", () => {
          setHasExistingStream(true);
          client.removeAllListeners();
          client.leave();
        });

        await client.join(
          rtcProps.appId,
          rtcProps.channel,
          rtcProps.token,
          null
        );
      } catch (error) {
        console.error("Error checking existing stream:", error);
      }
    };

    validateRoom();
    checkExistingStream();
  }, [roomid]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-800 space-x-4">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!loading && invalidRoom) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-800">
        <div className="p-8 rounded-lg">
          <div className="flex items-center mb-2 justify-center space-x-4">
            <MdOutlineErrorOutline className="w-9 h-9 text-red-400" />
            <h1 className="text-3xl font-bold text-center text-white">
              Invalid Room ID
            </h1>
          </div>
          <p className="text-gray-400 text-center">
            The room ID you are trying to access is invalid. Please check the
            link or contact support.
          </p>
        </div>
      </div>
    );
  }

  return videoCall && roomid ? (
    isTherapist ? (
      <div style={{ display: "flex", width: "100vw", height: "100vh" }}>
        <AgoraUIKit
          rtcProps={{
            appId: "5ac69d114f964bcb9913e6e909735f40",
            channel: roomid || "93400b7019e3458db34baa918bb0c318",
            token: null,
            enableScreensharing: true,
            role: "host",
            layout: layout.pin,
          }}
          styleProps={{
            videoMode:{
              max:"contain",
              min:"contain"
            }
          }}
          rtmProps={{ username: username || "user", displayUsername: true }}
          callbacks={callbacks}
        />
      </div>
    ) : (
      <div style={{ display: "flex", width: "100vw", height: "100vh" }}>
        <AgoraUIKit
          rtcProps={{
            appId: "5ac69d114f964bcb9913e6e909735f40",
            channel: roomid || "93400b7019e3458db34baa918bb0c318",
            token: null,
            enableScreensharing: true,
            // role: 'audience',
            layout: layout.pin,

          }}
          styleProps={{
            videoMode:{
              max:"contain",
              min:"contain"
            }
          }}
          rtmProps={{ username: username || "user", displayUsername: true }}
          callbacks={callbacks}
        />
        <img
        src={logo}
        alt="Watermark"
        style={{
          position: 'absolute',
          bottom: '20px',
          right: '20px',
          zIndex:100,
          width: '80px', // Adjust size as needed
          opacity: 1, // Adjust opacity as needed
          pointerEvents: 'none', // Prevents the logo from interfering with UI interactions
        }}
      />
      </div>
    )
  ) : isTherapist ? (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-800 text-white">
      <p>Welcome, {username}!</p>
      <br />
      <p>Video call will start shortly</p>
      <p>Valid room : {(!invalidRoom).toString()}</p>
      <p>Existing Stream : {hasExistingStream.toString()}</p>
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-lg"
        onClick={() => setVideoCall(true)}
      >
        Start Call
      </button>
      <div className="h-10" />
      <button
        className="bg-red-500 text-white px-4 py-2 rounded-lg"
        onClick={() => handleCloseTheRoom()}
      >
        Mark this Call/Room as completed
      </button>
      <p className="text-sm text-gray-400 mt-4">
        Note: You can't revert this action
      </p>
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-800 text-white">
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-lg"
        onClick={() => setVideoCall(true)}
      >
        Rejoin call
      </button>
    </div>
  );
};

export default AgoraNewVideoCall;
